import { useMemo, useEffect } from 'react'
import { UserTypes } from "@/configs/AppConfig";

const routeConfigModules = import.meta.glob('/src/app/**/route.jsx', {
    eager: true
});

const allRoutes = Object.keys(routeConfigModules)
    .map((modulePath) => {
        const moduleConfigs = routeConfigModules[modulePath]
            .default;
        return Array.isArray(moduleConfigs) ? moduleConfigs : [moduleConfigs];
    })
    .flat()

export default function useRoutes(userType) {
    const routes = useMemo(() => {
        if (!userType) return []
        return allRoutes.filter(route => route?.auth?.length && route?.auth?.length > 0)
            .filter(route => route.auth.includes(userType))
    }, [userType])
    return routes
}